
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { WelcomeComponent } from '../../shared/pages/0-welcome/welcome.component';
import { ProjectOverviewComponent } from '../../shared/pages/1-project-overview/project-overview.component';
import { EnvironmentalComponent } from 'src/app/shared/pages/2-environmental/environmental.component';
import { TrafficComponent } from 'src/app/shared/pages/3-traffic/traffic.component';
import { AlternativesComponent } from 'src/app/shared/pages/4-alternatives/alternatives.component';
import { PublicCommentComponent } from 'src/app/shared/pages/5-public-comment/public-comment.component';

@Component({
  selector: 'app-mobile-main-content',
  templateUrl: './mobile-main-content.component.html',
  styleUrls: ['./mobile-main-content.component.scss'],
  imports: [
    WelcomeComponent,
    ProjectOverviewComponent,
    EnvironmentalComponent,
    TrafficComponent,
    AlternativesComponent,
    PublicCommentComponent
],
})
export class MobileMainContentComponent implements OnInit {
  @ViewChild('contentDiv') contentDiv!: ElementRef;
  @ViewChild('pageContainer') pageContainer!: ElementRef;

  pageIndex = 0;

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.appService.getPageIndex().subscribe({
      next: (pageIndex: number) => {
        this.pageIndex = pageIndex;
        this.appService.emitScrollToTop();
      },
      error: (error) => {
        console.error('Error getting pageIndex:', error);
      },
    });
  }
}
